import React from 'react';

import { Typography, Card, CardHeader, CardContent } from '@occc/ui-design-system';
import { EarningMechanismFragment } from '@occc/graphql';
import { getEarningMechanismAward } from '@occc-app/offerHelpers/utils/getEarningMechanismAward';

import EarningMechanismConfiguration from './EarningMechanismConfiguration';
import Award from './Award';
import { awardTitle, earningMechanismTitle } from './constants';

interface IEarningMechanismProps {
  earningMechanism: EarningMechanismFragment;
}

export const EarningMechanism: React.FC<IEarningMechanismProps> = ({ earningMechanism }) => {
  const award = getEarningMechanismAward(earningMechanism);

  return (
    <>
      <Card>
        <CardHeader
          title={
            <Typography variant='h6' component='h4' gutterBottom>
              {earningMechanismTitle[earningMechanism.__typename]}
              <Typography
                component='span'
                fontSize='0.7rem'
                display='inline-block'
                mx={0.5}
                my={0}
                sx={{ verticalAlign: 'middle' }}
              >
                &#9679;
              </Typography>{' '}
              Earning Mechanism
            </Typography>
          }
        />
        <CardContent>
          <EarningMechanismConfiguration earningMechanism={earningMechanism} />
        </CardContent>
      </Card>
      {award && (
        <Card>
          <CardHeader
            title={
              <Typography variant='h6' component='h4' gutterBottom>
                {awardTitle[award?.__typename]} Award
              </Typography>
            }
          />
          <CardContent>
            <Award award={award} />
          </CardContent>
        </Card>
      )}
    </>
  );
};
